module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "autocomplete-input",
    class: _vm.styling
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    staticClass: "input",
    attrs: {
      "placeholder": _vm.searchPlaceholder,
      "autofocus": _vm.styling === 'inheader'
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "focus": _vm.searchFocus,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }, function($event) {
        _vm.onInput($event.target.value)
      }],
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27, $event.key)) { return null; }
        _vm.isOpen = false
      },
      "blur": _vm.searchBlur,
      "keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40, $event.key)) { return null; }
        _vm.moveDown($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38, $event.key)) { return null; }
        _vm.moveUp($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.select($event)
      }]
    }
  }), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOpen),
      expression: "isOpen"
    }],
    staticClass: "options-list"
  }, _vm._l((_vm.fOptions), function(option, index) {
    return _c('li', {
      class: {
        'highlighted': index === _vm.highlightedPosition
      },
      on: {
        "mouseenter": function($event) {
          _vm.highlightedPosition = index
        },
        "mousedown": _vm.select
      }
    }, [_vm._t("item", [_c('article', {
      staticClass: "media"
    }, [(option.name) ? _c('p', [_c('strong', [_vm._v(_vm._s(option.name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(option.category) + " (" + _vm._s(option.plcount) + ")")])]) : _vm._e(), _vm._v(" "), (option.plno && option.photos) ? _c('p', [_c('strong', [_vm._v("PL" + _vm._s(option.plno))]), _vm._v(" "), _c('span', [_vm._v("Location")])]) : _vm._e(), _vm._v(" "), (option.address && !option.tags) ? _c('p', [_c('strong', [_vm._v(_vm._s(option.address))]), _vm._v(" "), _c('span', [_vm._v("PL" + _vm._s(option.plno))])]) : _vm._e()])], {
      title: option.title,
      description: option.description,
      thumbnail: option.thumbnail
    })], 2)
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c9a38c7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Autocomplete.vue
// module id = 193
// module chunks = 1